import { Pagination } from '@mui/material';
import axios from 'axios';
import { useEffect, useRef, useState } from 'react';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { BACKEND_SERVER_URL } from '../../../http/http-config';
import SearchBox from '../Common-Components/SearchBox';
import '../common-css/Table.css';
import { showTableResponse, sortInAlphabeticalOrder } from '../common-helpers/commonServices';
import CUET_SubscribersModal from './CUET_SubscribersModal';


const CUET_Subscribers = () => {
    const childRef = useRef();
    const [subjects, setSubjects] = useState([]);
    // const [courses, setCourses] = useState([]);
    const [selectedCourse, setSelectedCourse] = useState("All Subject types");
    const [currentPage, setCurrentPage] = useState(1);
    const [checked, setChecked] = useState(subjects);
    const [loadSubjects, setSubjectLoading] = useState(false);
    console.log(selectedCourse)

    //set Table data
    useEffect(() => {
        axios.get(BACKEND_SERVER_URL + '/cuet/subscribers').then((res) => {
            let subjects = res.data.data;
            setSubjects(subjects);
            setChecked(subjects);
        }).catch((error) => {
            console.log(error)
            toast.error(error.response.data.message)
        })

    }, [loadSubjects])
    const pageSize = 100;
    const lastIndex = currentPage * pageSize;
    const firstIndex = lastIndex - pageSize;
    const records = checked?.slice(firstIndex, lastIndex);
    const npage = Math.ceil(checked?.length / pageSize)
    const number = [...Array(npage + 1).keys()].slice(1)

    const selectSubjectTypeHandler = (selectedSubjectType) => {
        if (selectedSubjectType == 'All Subject types') {
            setChecked(subjects);
            setSelectedCourse(selectedSubjectType);
            return;
        }
        setSelectedCourse(selectedSubjectType);
        let filteredSubjects = subjects.filter(subject => subject.ExamType == selectedSubjectType)
        console.log(filteredSubjects);
        setChecked(sortInAlphabeticalOrder(filteredSubjects, 'SubjectType'));
    }

    const toggleCUETSubscribersAccess = (sn, subjectId, checked) => {
        axios.post(BACKEND_SERVER_URL + '/cuet/toggleCUETSubscribersAccess', { sn, subjectId, checked }).then((res) => {
            toast.success(res.data.message);
            setSubjectLoading(!loadSubjects);
        }).catch((error) => {
            console.error('Toggle access error:', error);
            toast.error(error?.response?.data?.message || 'Error updating status. Check console.');
        })
    }

    return (
        <>
            <div className="row">
                <div className="col-xl-12">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className=" page-title p-2 mb-2">{/*  flex-wrap  */}
                                <div className="row w-100 d-flex justify-content-between">
                                    <div className=' col-sm-8 d-flex justify-content-between'>
                                        <div className="col-2">
                                            <button type="button" className=" btn btn-dark btn-sm "
                                                onClick={() => childRef.current.openModal()}
                                            >
                                                + Add
                                            </button>
                                        </div>
                                        <div className="col-10 d-flex justify-content-start ">
                                            <div className="col-6">
                                                <div className="basic-dropdown">
                                                    <Select
                                                        value={[
                                                            { value: 'All Subject types', label: 'All Subject types' },
                                                            { value: 'Section-IA', label: 'Language Subjects' },
                                                            { value: 'Section-II', label: 'Domain-Specific Subjects' },
                                                            { value: 'Section-III', label: 'General Aptitude Test' }
                                                        ].find(opt => opt.value === selectedCourse)}
                                                        onChange={(selectedOption) => selectSubjectTypeHandler(selectedOption.value)}
                                                        options={[
                                                            { value: 'All Subject types', label: 'All Subject types' },
                                                            { value: 'Section-IA', label: 'Language Subjects' },
                                                            { value: 'Section-II', label: 'Domain-Specific Subjects' },
                                                            { value: 'Section-III', label: 'General Aptitude Test' }
                                                        ]}
                                                        styles={{
                                                            control: (provided) => ({
                                                                ...provided,
                                                                width: '100%',
                                                                backgroundColor: 'transparent', // Adjust as needed
                                                                borderColor: '#17a2b8', // Adjust as needed

                                                            }),
                                                        }}
                                                    />
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                    <div className=" col-sm-4 input-group search-area mb-md-0 mb-3">
                                        <SearchBox setChecked={setChecked} dataArray={subjects} searchingProperty={'FirstName'} />
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="col-xl-12 wow fadeInUp" data-wow-delay="1.5s">
                            <div className="d-sm-flex text-center justify-content-between align-items-center">

                                <div className='dataTables_info text-dark'>
                                    Records: {checked.length}
                                </div>
                                {checked.length > pageSize ? <div className="dataTables_paginate paging_simple_numbers justify-content-center  mb-0 pt-2"
                                    id="example-student_wrapper">
                                    <Pagination count={number.length} variant="outlined" color='primary' size="small" page={currentPage} siblingCount={1} boundaryCount={2} onChange={(e, p) => setCurrentPage(parseInt(p))} />
                                </div> : null}
                            </div>
                            <div className="table-responsive full-data" style={{ paddingBottom: "1px", transform: 'rotateX(180deg)' }}>
                                <div id="example-student_wrapper" className="dataTables_wrapper no-footer">
                                    <table className="table-responsive-lg table display dataTablesCard student-tab 
                                    dataTable no-footer mt-0 mb-0" style={{ transform: 'rotateX(180deg)' }} id="example-student" >
                                        <thead style={{ backgroundColor: "#cccccc" }} >
                                            <tr className='text-center border border-left'>
                                                <th className='custom-table-header p-2 text-center' style={{ width: "50px" }}>Sl.No.</th>
                                                <th className='custom-table-header p-2 text-start ps-3'>NAME</th>
                                                <th className='custom-table-header p-2 text-start ps-3' style={{ width: "150px" }}>EMAIL ADDRESS</th>
                                                <th className='custom-table-header p-2 text-start ps-3' style={{ width: "110px" }}>MOBILE</th>
                                                <th className='custom-table-header p-2 text-start ps-3' style={{ width: "140px" }}>SUBJECT TYPE</th>
                                                <th className='custom-table-header p-2 text-start ps-3' style={{ width: "120px" }}>SUBJECT</th>
                                                <th className='custom-table-header p-2 text-center' style={{ width: "90px" }}>TEST COUNT</th>
                                                <th className='custom-table-header p-2 text-center' style={{ width: "80px" }}>ALLOW</th>
                                                <th className='custom-table-header p-2 text-center' style={{ width: "90px" }}>STATUS</th>
                                                <th className='custom-table-header p-2 text-center' style={{ width: "110px" }}>DATE</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {records.length > 0 ? records.map((item, ind) => (
                                                <tr key={ind} className={`${ind % 2 == 1 ? 'custom row-height' : 'row-height'}`} >
                                                    <td className='p-1 text-center' style={{ border: "1px solid #cccccc", width: "50px" }}>
                                                        <h6 className='mb-0' style={{ fontSize: '13px' }}>{firstIndex + ind + 1}</h6>
                                                    </td>

                                                    <td className='p-1 text-start' style={{ border: "1px solid #cccccc" }}>
                                                        <h6 className='mb-0 ps-3' style={{ fontSize: '13px', fontWeight: 'bold' }}>{item.FirstName} {item.LastName || ''}</h6>
                                                    </td>

                                                    <td className='p-1 text-start' style={{ border: "1px solid #cccccc", width: "150px" }}>
                                                        <h6 className='mb-0 ps-3' style={{ fontSize: '13px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.EmailId}</h6>
                                                    </td>

                                                    <td className='p-1 text-start' style={{ border: "1px solid #cccccc", width: "110px" }}>
                                                        <h6 className='mb-0 ps-3' style={{ fontSize: '13px' }}>{item.MobileNo || 'N/A'}</h6>
                                                    </td>

                                                    <td className='p-1 text-start' style={{ border: "1px solid #cccccc", width: "140px" }}>
                                                        <h6 className="mb-0 ps-3" style={{ fontSize: '13px' }}>
                                                            {item.ExamType === "Section-IA" ? "Language Subjects" : item.ExamType === "Section-II" ? "Domain-Specific Subjects" : item.ExamType === "Section-III" ? "General Aptitude Test" : item.ExamType}
                                                        </h6>
                                                    </td>

                                                    <td className='p-1 text-start' style={{ border: "1px solid #cccccc", width: "120px" }}>
                                                        <h6 className="mb-0 ps-3" style={{ fontSize: '13px' }}>
                                                            {item.SubjectType ?? 'Aptitude Test'}
                                                        </h6>
                                                    </td>

                                                    <td className='p-1 text-center' style={{ border: "1px solid #cccccc", width: "90px" }}>
                                                        <h6 className="mb-0" style={{ fontSize: '13px' }}>
                                                            {item.TestCount}
                                                        </h6>
                                                    </td>

                                                    <td className='p-1 text-center' style={{ border: "1px solid #cccccc", width: "80px" }}>
                                                        <h6 className=" form-check form-switch d-flex justify-content-center mb-0">
                                                            <input className="form-check-input cursor-pointer" type="checkbox" role="switch" id="flexSwitchCheckDefault" style={{ width: "35px", height: "16px", backgroundColor: `${item.Allow ? "#E0F5F0" : "#FFE8E8"}`, border: `1px solid ${item.Allow ? 'green' : "red"}` }} checked={!!item.Allow} onChange={() => toggleCUETSubscribersAccess(item.Sn, item.SubjectID, item.Allow)} />
                                                        </h6>
                                                    </td>

                                                    <td className='p-1 text-center' style={{ border: "1px solid #cccccc", width: "90px" }}>
                                                        <h6 className="mb-0" style={{ color: `${item.Allow ? 'green' : 'red'}`, fontWeight: 'bold', fontSize: '13px' }}>
                                                            {item.Allow ? 'Active' : 'Inactive'}
                                                        </h6>
                                                    </td>

                                                    <td className='p-1 text-center' style={{ border: "1px solid #cccccc", width: "110px" }}>
                                                        <h6 className="mb-0" style={{ fontSize: '13px' }}>
                                                            {item.PaymentDate ? new Date(item.PaymentDate).toLocaleDateString() : 'N/A'}
                                                        </h6>
                                                    </td>
                                                </tr>
                                            )) :
                                                <tr>
                                                    <td colSpan="11" className="text-center">
                                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px' }}>
                                                            {
                                                                showTableResponse(subjects, checked)
                                                            }
                                                        </div>
                                                    </td>
                                                </tr>}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <CUET_SubscribersModal ref={childRef} loadSubjects={loadSubjects} setSubjectLoading={setSubjectLoading} />
        </>
    )
}

export default CUET_Subscribers;
